import React, { useState, useEffect } from "react";
import Sub_header from './Sub_header'

import axios from "axios";


import exportValue from "../apiconfig";
import ReactLoading from 'react-loading';
import Swal from 'sweetalert2'
import Left_panel from "./Left_panel";
// import '../../components/loader.css';


const Rate_calculator_int = () => {
    
   
    const[dimensionState,setdimensionState] = React.useState({companyDetail:[]})

    const[parceltype,setparceltypeState] = React.useState({parcel:true})
    const[documenttype,setdocumenttypeState] = React.useState({document:false})
    const[state,setState] = React.useState({  parcel_type:"Parcel" , from_postal_code:"" ,to_postal_code:"" , mode:"International" , weight:"" , length:"" , width:"" , height:"" , country_name:"" })
    // console.log("state === " , state)
    const[active , setactive]= React.useState(1)
    const [statepackage, setStatepackage] = React.useState([]);
    const[loadingstate,setLoadingstate] = React.useState({loading:false})
    const[errorstate,seterrorstate] = React.useState({message:""})
  const[paymentmode,setpaymentmode]= React.useState({mode:1})
  const [codvalue,setcodvalue] = React.useState({cod_amount:0 , err:{}})
  const[volume, setVolume] = React.useState()
  const [countryList, setcountryList] = React.useState([]);
  const[volstate , setVolstate] = React.useState(1)
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

   const toggleSidebar = () => {
       setIsSidebarOpen(!isSidebarOpen);
       const homeSection = document.querySelector('.home-section');
       if (homeSection) {
           homeSection.classList.toggle('sidebar-closed');
       }
   };
 
  React.useEffect(()=>{
      getCountryList()
    },[])

    const handleChange=(e)=>{
        console.log("namess",e.target.name)
        console.log("value",e.target.value)
        console.log("type",e.target.type)

       
        let names = e.target.name
        let value= e.target.value
       
        if(e.target.type=="text"){
        setState({...state,[e.target.name]:value})
        }
        else if(e.target.type =="select-one"){
          setState({...state,[e.target.name]:value})
        }
        else if(e.target.type=="radio"){
            if(e.target.checked==true){
              
                 if(e.target.name=="document"){
                  setparceltypeState({...parceltype,parcel:false})
                  setdocumenttypeState({...documenttype,document:true})
                  setState({...state,parcel_type:"Document"})
                }
                else{
                  setparceltypeState({...parceltype,parcel:true})
                  setdocumenttypeState({...documenttype,document:false})
                  setState({...state,parcel_type:"Parcel"})
                }
            }
        }
        else if(e.target.type=="number"){
          setState({...state,[e.target.name]:value})
        }
        else if(e.target.type=="date"){
            setState({...state,[e.target.name]:value})
           
        }
    }

   
    
    const get_list_international = async (sortValue) => {
      setLoadingstate({...loadingstate,loading:true})
      if(state.country_name!="" && state.mode!="" && state.parcel_type!="" && state.weight!="" && state.height!="" && state.width!="" && state.length!=""){
     if(paymentmode.mode==1 || paymentmode.mode==2 && codvalue.cod_amount!="" ){

      let sort = "default";
      if(sortValue) {
        sort = sortValue
      }
      let dataToSend = {
        weight:volume && state.weight!=""?parseFloat(volume)>parseFloat(state.weight)?volume:state.weight:0.00,
         length:state.length,
         height:state.height,
         width:state.width,
         sort_by:sort ,
          parcel_type:state.parcel_type ,
           mode:state.mode,
           payment_mode:paymentmode.mode==2?"cod":"prepaid",
           order_amount:codvalue.cod_amount,
           carrier_type:1,
          
            from_country_code:"IN" ,
           
            
              to_country_code:"IN" ,
              to_country:state.country_name
              
    };
    
      // console.log("datatoSend",dataToSend)
      let url = exportValue.host + "/" + exportValue.version + "/" + exportValue.api  + '/international_shipment_rate_time';
       axios.post(url, dataToSend, { headers: exportValue.headers })
          .then((responseJson) => {
            // console.log("responseJson => ", responseJson.data);
            setLoadingstate({...loadingstate,loading:false})
            if(responseJson.data.status=="success"){
              setStatepackage(responseJson.data.output)
              if(responseJson.data.output.length==0){
                seterrorstate({...errorstate,message:"No services available for the selected route and package combination."})
              }
            }
  
            else{
            
              const Toast = Swal.mixin({
                  toast: true,
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000
                })
                Toast.fire({
                  background:"#a61c09",
                  type: 'Unsuccess',
                  title: responseJson.data.message,
                  color:"white"
                });
            }
             
          })
          .catch((error) => {
              //Hide Loader
              setLoadingstate({...loadingstate,loading:false})
              // console.log(error);
          });
        }
        else{
          const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
          })
          
          Toast.fire({
            background:"#a61c09",
            type: 'unsuccess',
            title: "Please enter cod value",
            color:"white"
          });
          setLoadingstate({...loadingstate,loading:false})

         }
      }
      else{
          const Toast = Swal.mixin({
              toast: true,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000
            })
            Toast.fire({
              background:"#a61c09",
              type: 'Unsuccess',
              title: "Please Fill All the Fields",
              color:"white"
            });
            setLoadingstate({...loadingstate,loading:false})

      }
  };
    
   
    React.useEffect(() => {
        
        dimension_detail()    
    }, [])
    const dimension_detail = () =>{
        let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/company_info_api`;
        let sendData = {};
      
        axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
          setdimensionState({...dimensionState,companyDetail:res.data.companyDetail});
        }).catch((e) => {
        })
      }

      const reset =()=>{
        setState({...state , parcel_type:"Parcel" , from_postal_code:"" ,to_postal_code:"" , mode:active==0?"Domestic":"International" , weight:"" , length:"" , width:"" , height:"" , country_name:""})
        setdocumenttypeState({...documenttype,document:false})
        setparceltypeState({...parceltype,parcel:true})
        setcodvalue({...codvalue,cod_amount:0 , err:{}})
      }
      const payment_mode =(e)=>{
        if(e.target.name=="prepaid"){
          setpaymentmode({mode:1})
        }
        else{
          setpaymentmode({mode:2})
        }
      }
      const codvalueChange=(e)=>{
      
        setcodvalue({...codvalue,cod_amount:e.target.value , err:{}})
      }
     
      
      React.useEffect(() => {
        if ( state.height !== "" && state.width !== "" && state.length !== "") {
            let divisor = volstate === 1 ? 5000 : 1;
            const calculatedVolume = ( state.height * state.width * state.length) / divisor;
            setVolume(calculatedVolume.toFixed(2));
        } else {
            setVolume(0);
        }
    }, [ state.height, state.width, state.length, volstate]);

    const getCountryList = () => {


      let url = exportValue.host + "/" + exportValue.version + "/" + exportValue.api +  '/country_list_international';
      let sendData = {limit:300 , status:1};
      // console.log("bb", sendData);
      axios.post(url, sendData, { headers: exportValue.headers}).then((res) => {
          // console.log("res ", res);           
          setcountryList(res.data.output)
  
  
      }).catch((e) => {
  
  
      });
  }
  return (
    <div>
      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
       
       <section class="home-section">
               {/* <?php
               include('sub_header.php');
               ?>  */}
           
       <Sub_header/>

      <div className=''>
      <div class="row py-3">
            <div class="col-12 col-md">
                <div class="card border-0 order_box shadow-sm">
                    <div class="card-body">
                        <section class="pb-5">
                            <div class="row">
                                <div class="col-12 col-md-12 mb-3">
                                    <label for="" class="form-label">Shipment Type:</label>
                                    <div>
                                        <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio"  onChange={(e)=>handleChange(e)} name="document" id="inlxineRadio1"  checked={documenttype.document==true && parceltype.parcel==false}/>
                                          <label class="form-check-label" for="inlineRadio1">Document</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="parcel" onChange={(e)=>handleChange(e)} id="inlixneRadio2" value={state.parcel_type} checked={parceltype.parcel==true && documenttype.document==false }/>
                                          <label class="form-check-label" for="inlineRadio2">Parcel</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12 mb-3">
                                    <label for="" class="form-label">Delivery Country:</label>
                                    <select class="form-select form-select-sm" name="country_name" onChange={(e)=>handleChange(e)}>
                               <option >Select</option>
                               {countryList.map((item)=>{
           return (
             <option value={ item.country_name}>{item.country_name}</option>
         )
          
})}
                               </select>
                                </div>
                                {/* <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Delivery Pincode:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter delivery pincode" name="to_postal_code" value={state.to_postal_code} onChange={(e)=>handleChange(e)} />
                                </div> */}
                                <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Actual Weight:</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" placeholder="Enter Weight"  name="weight"  onChange={(e)=>handleChange(e)} value={state.weight}/>
                                        <span class="input-group-text">KG</span>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Dimensions:</label>
                                    <div class="row">
                                        <div class="col-12 col-md-4 mb-3">
                                            <div class="input-group">
                                                <input type="text" class="form-control" placeholder="H" onChange={(e)=>handleChange(e)} name="height" value={state.height}/>
                                                <span class="input-group-text">CM</span>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4 mb-3">
                                            <div class="input-group">
                                                <input type="text" class="form-control" placeholder="W" onChange={(e)=>handleChange(e)} name="width"  value={state.width}/>
                                                <span class="input-group-text">CM</span>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4 mb-3">
                                            <div class="input-group">
                                                <input type="text" class="form-control" placeholder="L" onChange={(e)=>handleChange(e)} name="length" value={state.length}/>
                                                <span class="input-group-text">CM</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Mode:</label>
                                    <div>
                                        <div class="form-check form-check-inline">
                                          <input class="form-check-input" type="radio" name="cod" id="inlineRadio2" value="option2" onChange={(e) => payment_mode(e)} checked={paymentmode.mode==2} />
                                          <label class="form-check-label" for="inlineRadio1">Cash On Delivery</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                          <input class="form-check-input" type="radio" name="prepaid" id="inlineRadio1" value="option1" onChange={(e) => payment_mode(e)} checked={paymentmode.mode==1}  />
                                          <label class="form-check-label" for="inlineRadio2">Prepaid</label>
                                        </div>
                                    </div>
                                </div>
                                {paymentmode.mode==2?
                    <div class="row">
                      <div class="col-12 col-md-5 mb-3">
                        <input type="text" class="form-control" id="" placeholder="Enter COD amount" name="cod_amount" 
                        onChange={(e)=>codvalueChange(e)} value={codvalue.cod_amount} />
                      </div>
                  </div>:""}
                               
                            </div>
                            <h6>Volumetric Weight <span class="ms-5">{volume} Kg</span></h6>
                  
                    <h6 class="mb-3 mt-3">Applicable Weight  <span className='ms-5'>{volume && state.weight !== "" ? 
  (parseFloat(volume) > parseFloat(state.weight) ? volume : state.weight) + " Kg" :
  "0.00 Kg"
}</span> </h6>
                            <div>
                                <a onClick={()=>get_list_international()} class="btn btn-primary">Calculate</a>
                                <a onClick={()=>reset()} class="btn btn-outline-primary">Reset</a>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4">
                
            </div>
        </div>
        
        
        <section class="package_box">
                  {loadingstate.loading?
            <div style={{width:"100%", display: "flex",
    justifyContent: "center"}}>
  
      
          <ReactLoading type={"spin"} color={"#0d6efd"} height={300} width={89} />
          </div>
          :""}
           <h3>
              {errorstate.message}</h3>
                      <div class="card mb-3">
                      {(statepackage.length != 0) ?
            statepackage.map((item,index)=>
                        <div class="card-body">
                           <div className='card '>
                                    <div className='card-body'>
                          <div class="row">
                              <div class="col-12 col-md">
                                  <div class="d-flex">
                                      <div class="p-2">
                                      {item.carrier_id!="1731744190"&& item.carrier_id!="1009992210"?
                                          <figure>
                                              <img src={`https://shiprocketcdn.fniix.com/images/${item.carrierImage}`} class="img-fluid" />
                                          </figure>
                                          :""}
                                      </div>
                                      <div class="ps-2 ">
                                          <h4>{item.service_provider}</h4>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-12 col-md-4 text-end">
                                  <h6>{item.product_type_name?item.product_type_name:""} 
                                  {/* | Min-weight: 0.5 kg */}
                                  </h6>
                              </div>
                          </div>
                         
                          <div class="row">
                              {/* <div class="col-12 col-md-2">
                                  <div class="card rating_card">
                                    <div class="card-body">
                                      <h5>Rating 3.5</h5>
                                      <div class="text-warning">
                                          <i class="material-icons-outlined">star</i>
                                          <i class="material-icons-outlined">star</i>
                                          <i class="material-icons-outlined">star</i>
                                          <i class="material-icons-outlined">star_half</i>
                                          <i class="material-icons-outlined">star_border</i>
                                      </div>
                                    </div>
                                  </div>
                              </div> */}
                              <div class="col-12 col-md pt-3">
                                  <h5>Expected Pickup</h5>
                                  <small>-----</small>
                              </div>
                              <div class="col-12 col-md pt-3">
                                  <h5>Estimated Delivery</h5>
                                  <small>----</small>
                              </div>
                              <div class="col-12 col-md pt-3">
                                  <h5>Weight</h5>
                                  <small>-----</small>
                              </div>
                              <div class="col-12 col-md pt-3">
                                  <h3>{dimensionState.companyDetail.map((subscriber)=>( 
                                    <>{subscriber.set_currency}</>
                                   ))}{parseFloat(Number(item.total_charges)+Number(item.commission_charge)).toFixed(2)}</h3>
                              </div>
                              {/* {(otherState.submit_button) ? */}
                            
                                 
                              {/* :  <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={60} />} */}
                          </div>
                          {/* <div className="mt-3">
                          <hr/>
                          </div> */}
                        </div>
                        </div>
                        </div>
                        
                        ):""}
                      </div>
                   
                      
                    
                  </section>
                   </div>
     </section>
    </div>
  )
}

export default Rate_calculator_int
